/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationIdKind = (typeof GroupByConversationIdKind)[keyof typeof GroupByConversationIdKind];

export const GroupByConversationIdKind = {
  conversation_id: 'conversation_id',
} as const;
